const APSPrescriberDrugList = [
    "nicovape",
    "aiero",
    "allo sync",
    "hqd",
    "iget",
    "veev",
    "wild by instinct",
    "zefir"
];

export default APSPrescriberDrugList;
